// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CloseCircleOutlinedSvg from "@fishx/icons-svg/es/asn/CloseCircleOutlined";
import FishxIcon from '../components/FishxIcon';

var CloseCircleOutlined = function CloseCircleOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CloseCircleOutlinedSvg
  }));
};

CloseCircleOutlined.displayName = 'CloseCircleOutlined';
export default React.forwardRef(CloseCircleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CloseCircleOutlined.js
// module id = 2229
// module chunks = 0